import { ChangeDetectionStrategy, Component, ViewChild, ElementRef, OnInit, Input, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IndPageTitleViewDataModel } from '@omni/models/indPageTitleDataModel';
import { NavigationService, PageName } from '@omni/services/navigation/navigation.service';
import { AccountOfflineService } from '../../../services/account/account.offline.service';
import { data } from 'jquery';
import { AccountDataService } from '@omni/data-services/accounts/account.data.service';
import { Account } from '@omni/classes/account/account.class';
import { FooterViews, FooterService } from '@omni/services/footer/footer.service';
import { ComponentViewMode, UIService } from '@omni/services/ui/ui.service';
import { DynamicFormsService } from '@omni/services/dynamic-forms/dynamic-forms-service';
import { DeviceService } from '@omni/services/device/device.service';
import { ContactOfflineService } from '@omni/services/contact/contact.service';
import { EventsService } from '@omni/services/events/events.service';
import { IonContent } from '@ionic/angular';
import { IndSectionHeaderViewDataModel } from '@omni/models/indSectionHeaderDataModel';
import { PopoverController } from '@ionic/angular';
import { MultiSelectPopover } from '@omni/components/multi-select-popover/multi-select-popover';
import { Contact } from '@omni/classes/contact/contact.class';
import { NotificationService, ToastStyle } from '@omni/services/notification/notification.service';
import { ACCOUNT_ACCOUNT_AFFILIATIONS_REF_ENTITY, ACCOUNT_CONTACT_AFFILIATIONS_REF_ENTITY } from '@omni/config/dynamic-forms/affiliations-contants';
import { DB_KEY_PREFIXES } from '@omni/config/pouch-db.config';
import { AuthenticationService } from '@omni/services/authentication.service';
import { FeatureActionsMap } from '@omni/classes/authentication/user.class';
import { cloneDeep, isEmpty, isEqual, uniqBy } from 'lodash-es';

@Component({
  selector: 'affiliation-explorer',
  templateUrl: 'affiliation-explorer.html',
  styleUrls: ['affiliation-explorer.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class AffiliationExplorerComponent implements OnInit {
  @Input() parent
  @Input() relatedTo;
  @Input() relatedFrom;
  @Input() contactAccountAffiliation; // this variable for both account and contact
  @Input() accountToBrand
  @Input() from: string;
  @ViewChild('chart', { static: true }) private chartContainer: ElementRef;
  @ViewChild(IonContent, { static: true }) private ionContent: IonContent;
  public affiliationFilterViewData: IndSectionHeaderViewDataModel;
  private filterBy: { text: string, value: string, asc: boolean };
  private selectedFilterByValue = ['all'];
  private selectedSourceTypeFilterByValue = 'all';
  private filterByDisplay : string;
  private filterAffiliationData;
  private data;
  private source;
  affiliationPageTitle: IndPageTitleViewDataModel = {
    id: 'affililiation-page',
    title: this.translate.instant('AFFILIATION_EXPLORER'),
    controls: [
      {
        id: "close",
        icon: "chevron-back-outline",
        isDisabled: false,
        align: "left"
      }
    ]
  };

  constructor(public navService: NavigationService,
    private translate: TranslateService,
    private accountOfflineService: AccountOfflineService,
    private uiService: UIService,
    private dynamicFormService: DynamicFormsService,
    private readonly footerService: FooterService,
    private accountDataService: AccountDataService,
    private device: DeviceService,
    private events: EventsService,
    private contactOfflineService: ContactOfflineService,
    public popover: PopoverController,
    private notificationService: NotificationService,
    public authenticationService: AuthenticationService) {
  }
  ngOnInit() {
    this.filterAffiliationData = [
      {
        text: "",
        expanded: true,
        value: "all",
        selectedValues: ["all"],
        multiselect: true,
        items: [
          { text: this.translate.instant('ALL'), value: "all", asc: true },
          { text: this.translate.instant('CONTACT_AFFILIATIONS'), value: "contact", asc: true },
          { text: this.translate.instant('ACCOUNT_AFFILIATIONS'), value: "account", asc: false },
          {
            text: this.translate.instant('SOURCE_TYPE'),
            expanded: true,
            value: 'all',
            items: [
              { text: this.translate.instant('ALL'), value: 'all', filterBy: 'sourceType' },
              { text: this.translate.instant('BUSINESS_AFFILIATIONS'), value: 'Business', filterBy: 'sourceType' },
              { text: this.translate.instant('MDM_AFFILIATIONS'), value: 'MDM', filterBy: 'sourceType' },
            ],
            handler: (selectedItem, item) => {
              item.value = selectedItem.value;

              this.selectedSourceTypeFilterByValue = selectedItem.value;

              if (this.source && selectedItem.value) {
                this.data = cloneDeep(this.source);
                this.affiliationFilter(this.data, this.selectedFilterByValue, this.selectedSourceTypeFilterByValue);
                this.chartContainer.nativeElement.innerHTML = "";
                this.renderChart();
              }
              this.initFilterHeader();
            }
          }
        ],
        handler: (selectedItem, item, itemRef, selected?: boolean) => {
          this.onFilterChange(selectedItem, item, itemRef, selected)
            item.value = selectedItem.value;
            this.filterBy = selectedItem;
            let filterByDisplayArr = [];
            itemRef.selectedValues.forEach(
              (data) => {
               let selectedItemData = item.items.find((itemdata) => data === itemdata.value );
               if(selectedItemData) {
                filterByDisplayArr.push(selectedItemData.text);
                filterByDisplayArr = Array.from(new Set(filterByDisplayArr));
               }
              }
              );
              this.filterByDisplay = filterByDisplayArr.join(", ")
          if (this.source && selectedItem.value) {
            this.data = cloneDeep(this.source);

            this.selectedFilterByValue = itemRef.selectedValues;

            this.affiliationFilter(this.data, this.selectedFilterByValue, this.selectedSourceTypeFilterByValue);
            this.chartContainer.nativeElement.innerHTML = "";
            this.renderChart();
          }
          this.initFilterHeader();
        }
      }
    ];
    // this.filterAffiliationData[0].value = "all";
    // this.filterAffiliationData[0].selectedValues = ["all"];
    this.filterByDisplay = this.translate.instant('ALL');

    this.filterBy = this.filterAffiliationData[0].items[0];
    this.initFilterHeader();
    if (this.from === "ContactPageComponent") {
      this.data = {
        entity_id: this.parent.ID,
        name:this.parent.fullname && this.parent.fullname.length > 20 ? this.parent.fullname.substring(0, 20).concat("...") : this.parent.fullname,
        value: 100,
        fill: '#007AFF',
        stroke: '#0361CA',
        affiliationRole: '',
        affiliationSourceType: this.parent.raw["indskr_contactsourcetype_Formatted"],
        affiliationType: '',
        relationship: '',
        icon: 'assets/imgs/contact-affiliation.svg',
        children: this.formatAffiliationDataFromContactRelationship(this.relatedTo, this.relatedFrom, this._contactRootAccountRows())
      }
    } else if (this.from === "AccountPageComponent") {
      const rootRows = this._rootAffiliationRows();
      this.data = {
        entity_id: this.parent.id,
        name: this.parent.accountName && this.parent.accountName.length > 20 ? this.parent.accountName.substring(0, 20).concat("...") : this.parent.accountName,
        value: 100,
        fill: '#E64969',
        stroke: '#BF1D3E',
        affiliationRole: '',
        affiliationSourceType: this.parent.raw["indskr_accountsourcetype_Formatted"],
        affiliationType: '',
        relationship: '',
        icon: 'assets/imgs/account-affiliation.svg',
        children: this.formatAffiliationDataFromAccountRelationship(rootRows.relatedTo, rootRows.relatedFrom, rootRows.accountContact, this.accountToBrand)

      }
      this.filterAffiliationData[0].items.splice(3,0,{ text: this.translate.instant('BRAND_AFFILIATION'), value: "brand", asc: false });
    }
    this.source = cloneDeep(this.data);
    this.renderChart()
    // Not awaited: the tree paints from the position-scoped inputs first and is rebuilt
    // if the beyond-position list differs, matching how the Info tab refills. Only runs when
    // nothing was published - which is what covers the entry points that never load the
    // display form (both timeline pages, omnichannel, sentiment history).
    this._refreshRootBeyondPosition();
    this._refreshContactRootBeyondPosition();

  }

  private onFilterChange(selectedItem, item, itemRef = null, selected?: boolean) {
    if(selectedItem && selectedItem.value){
      const val = selectedItem.value;
      let filters = [];
      if (isEqual(val, "all")) {
       filters = ["all"];
      } else {
        filters = itemRef.selectedValues.filter(v => !isEqual(v, "all"));
        if (!selected) filters = itemRef.selectedValues.filter(v => !isEqual(v, val));
        const availableFilters = this.filterAffiliationData[0].items.filter(i => !isEqual(i.value, "all")).length;
        if (isEmpty(filters) || filters.length == availableFilters) filters = ["all"];;
      }
      itemRef.selectedValues = this.filterAffiliationData[0].selectedValues = filters;
      this.filterAffiliationData[0].value = val;
    }

  }

  private async renderChart() {
    var tooltip = d3.select(".tooltip");
    if (tooltip.size() == 0) {
      tooltip = d3.select("body")
        .append("div")
        .style("opacity", 0)
        .attr("class", "tooltip")
        .style("background-color", "#ffffff")
        .style("border-radius", "8px")
        .style("padding", "5px")
        .style("border", "none")
        .style("box-shadow", "0px 10px 25px rgba(0, 0, 0, 0.2)");
    }
    let aeThis = this;

    const scrollElement = await aeThis.ionContent.getScrollElement();
    // Cleared after the await: the initial render and the beyond-position refresh can overlap,
    // and each would otherwise append its own svg.
    this.chartContainer.nativeElement.innerHTML = "";
    var margin = {
      top: 20,
      right: 120,
      bottom: 120,
      left: 180
    },
      width = 1200 - margin.right - margin.left,
      height = scrollElement.clientHeight - margin.top - margin.bottom;

    var i = 0,
      duration = 750,
      root;

    var tree = d3.layout.tree().size([height, width]);
    var diagonal = d3.svg.diagonal()
      .projection(function (d: any) {
        return [d.y, d.x];
      });

    var svg = d3.select("#render").append("svg")
      .attr("width", width + margin.right + margin.left)
      .attr("height", height + margin.top + margin.bottom)
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
    this.data.children?.forEach(d => d.name = d.name && d.name.length > 20 ? d.name.substring(0, 20).concat("...") : d.name);
    root = this.data;
    root.x0 = height / 2;
    root.y0 = 0;

    root.children.forEach(collapse);
    update(root);

    function collapse(d: any) {
      if (d.children) {
        d._children = d.children;
        d._children.forEach(collapse);
        d.children = null;
      }
    }

    function update(source) {
      var newHeight = Math.max(tree.nodes(root).reverse().length * 30, height);
      d3.select("#render svg")
        .attr("width", margin.left + margin.right + 300 +(source.depth * 180))
        .attr("height", newHeight + margin.top + margin.bottom);
      tree = d3.layout.tree().size([newHeight, width]);
      var nodes = tree.nodes(root).reverse(),
          links = tree.links(nodes);
      nodes.forEach(function (d: any) {
        d.y = d.depth * 180;
      });

      var node = svg.selectAll("g.node")
        .data(nodes, function (d: any) {
          return d.id || (d.id = ++i);
        });

      var nodeEnter = node.enter().append("g")
        .attr("class", "node")
        .attr("transform", function (d: any) {
          return "translate(" + source.y0 + "," + source.x0 + ")";
        })
        .on("click", click);

      nodeEnter.append("text")
        .attr("x", function (d: any) {
          return 15;
        })
        .attr("dy", ".35em")
        .attr("text-anchor", function (d: any) {
          return "start";
        })
        .text(function (d: any) {
          return d.name;
        })
        .style("fill-opacity", 1e-6);

      var nodeUpdate = node.transition()
        .duration(duration)
        .attr("transform", function (d: any) {
          return "translate(" + d.y + "," + d.x + ")";
        });

      nodeUpdate.select('text')
        .style("fill-opacity", 1)
        .text((d) => { return d.name; })
        .attr("text-anchor", function (d) {
          return d.children ? "end" : "start";
        })
        .attr("x", function (d) {
          return d.children ? -15 : 15;
        })
        .style('font-weight', (d) => {
          if (d.children) {
            return d._children ? 'font-weight' : '550';
          } else {
            return d.children ? 'font' : '400';
          }
        })
        .style('font-size', (d) => {
          if (d.children) {
            return d._children ? 'font-size' : '12px';

          } else {
            return d.children ? 'font' : '12px ';
          }
        })

      nodeEnter.append('circle')
        .attr('class', 'node')
        .attr('r', 1e-6)
        .style('fill', (d) => {
          return d._children ? 'blue' : '#fff';
        })

      nodeUpdate.select('circle.node')
        .attr('r', 10)
        .style('stroke-width', '3px')
        .style('stroke', (d) => {
          if (d.children) {
            return d.stroke
          }
          else {
            return d.fill
          }
        })
        .style('fill', (d) => {
          return d.fill
        })
        .attr('cursor', 'pointer');

      nodeEnter.append("svg:image")
        .attr("xlink:href", (d: any) => {
          return d.icon;

        })
        .attr("x", -8)
        .attr("y", -8)
        .attr("width", 16)
        .attr("height", 16);

      nodeUpdate.select("text")
        .style("fill-opacity", 1);

      var nodeExit = node.exit().transition()
        .duration(duration)
        .attr("transform", function (d: any) {
          return "translate(" + source.y + "," + source.x + ")";
        })
        .remove();

      nodeExit.select("circle")
        .attr("r", 1e-6);

      nodeExit.select("text")
        .style("fill-opacity", 1e-6);

      var link = svg.selectAll("path.link")
        .data(links, function (d: any) {
          return d.target.id;
        });

      link.enter().insert("path", "g")
        .attr("class", "link")
        // Dashed when the record at the far end is not in the rep's position. A separate
        // visual channel from the node colours, which already carry record type.
        .attr("stroke-dasharray", (d: any) => aeThis._isOutsidePosition(d.target) ? '4,4' : null)
        .attr("d", function (d: any) {
          var o = {
            x: source.x0,
            y: source.y0
          };
          return diagonal({
            source: o,
            target: o
          });
        });

      link.transition()
        .duration(duration)
        .attr("d", diagonal);

      link.exit().transition()
        .duration(duration)
        .attr("d", function (d: any) {
          var o = {
            x: source.x,
            y: source.y
          };
          return diagonal({
            source: o,
            target: o
          });
        })
        .remove();

      nodes.forEach(function (d: any) {
        d.x0 = d.x;
        d.y0 = d.y;
      });
      if (aeThis.device.isNativeApp && !aeThis.device.deviceFlags.electron) {
        let timer;
        nodeEnter.on("touchstart", function (d) {
          const event: any = d3.event;
          timer = setTimeout(() => {
            if (!isEmpty(event.changedTouches)) {
              tooltipPopOver(d, event.changedTouches[0].pageX, event.changedTouches[0].pageY);
            }
            else {
              tooltipPopOver(d, event['pageX'], event['pageY']);
            }
          }, 1000);
        })
        nodeEnter.on("touchend", () => {
          if (timer) {
            clearTimeout(timer);
            timer = null;
          }
          setTimeout(() => {
            tooltip.style("opacity", 0).style("z-index", -10000);
          }, 2000);
        });
      } else {
        let timer;
        nodeEnter.on('mouseover', (d) => {
          if (timer) {
            clearTimeout(timer);
            timer = null;
          }
          if (d?.type != 'brand') tooltip.style("opacity", 1).style("z-index", 10000);
        })
        nodeEnter.on("mousemove", (d) => {
          if (d?.type != 'brand') {
            tooltipPopOver(d, d3.event['pageX'], d3.event['pageY']);
          }
        }).on("mouseout", () => {
          timer = setTimeout(() => { tooltip.style("opacity", 0).style("z-index", -10000); }, 2000);
        });
      }

    }


    async function click(selected: any) {
      if (selected?.type == 'brand') return;
      if (selected?.depth > 3 || aeThis.data.entity_id == selected.entity_id) return;
      if (isEmpty(selected.children)) {
        let selectedDataChildren;
        if (selected.type == "account") {
          let account: Account = aeThis.accountOfflineService.getAccountById(selected.entity_id);
          if (!account && aeThis.authenticationService.hasFeatureAction(FeatureActionsMap.ACCOUNT_GLOBAL_SEARCH)) {
            try{
              aeThis.uiService.displayLoader();
              let accountData = await aeThis.accountDataService.fetchUnmappedAccountsLinkedEntityData(selected.entity_id);
              aeThis.uiService.dismissLoader();
              if (aeThis.filterBy.value) {
                selectedDataChildren = aeThis.filterAccountAffiliationOnclick(accountData.linkEntityAccountFrom, accountData.linkEntityAccountTo, accountData.linkedAccountContact, accountData.brandAffiliationByAccountId);
              } else {
                selectedDataChildren = aeThis.formatAffiliationDataFromAccountRelationship(accountData.linkEntityAccountTo, accountData.linkEntityAccountFrom, accountData.linkedAccountContact, accountData.brandAffiliationByAccountId);
              }
            }
            catch (error) {
              aeThis.uiService.dismissLoader();
              console.error('getUnmappedAccountAffiliations: ', error);
            }
          } else{
            let accountData = await aeThis._accountRelationshipData(selected.entity_id);
            if (aeThis.filterBy.value) {
              selectedDataChildren = aeThis.filterAccountAffiliationOnclick(accountData.linkEntityAccountFrom, accountData.linkEntityAccountTo, accountData.linkedAccountContact, accountData.brandAffiliationByAccountId);
            } else {
              selectedDataChildren = aeThis.formatAffiliationDataFromAccountRelationship(accountData.linkEntityAccountTo, accountData.linkEntityAccountFrom, accountData.linkedAccountContact, accountData.brandAffiliationByAccountId);
            }
          }
        } else {
          let contact: Contact = aeThis.contactOfflineService.getContactByID(selected.entity_id);
          if (!contact && aeThis.authenticationService.hasFeatureAction(FeatureActionsMap.CONTACTS_GLOBAL_SEARCH)) {
            try{
              aeThis.uiService.displayLoader();
              let contactData = await aeThis.contactOfflineService.fetchUnmappedContactsLinkedEntityData(selected.entity_id);
              aeThis.uiService.dismissLoader();
              if (aeThis.filterBy.value) {
                selectedDataChildren = aeThis.filterContactAffiliationOnclick(contactData["contactRealtedFrom"], contactData["contactRelatedTo"], contactData["contactToAccount"]);
              }
              else{
                selectedDataChildren = aeThis.formatAffiliationDataFromContactRelationship(contactData["contactRelatedTo"], contactData["contactRealtedFrom"], contactData["contactToAccount"]);
              }
            } catch(error){
              aeThis.uiService.dismissLoader();
              console.error('getUnamppedContactAffiliations: ', error);
            }
          } else{
            const contactRows = await aeThis._contactRelationshipData(selected.entity_id);
            let contactRelatedTo = contactRows.contactRelatedTo;
            let contactRealtedFrom = contactRows.contactRealtedFrom;
            let contactToAccount = contactRows.contactToAccount;
            if (aeThis.filterBy.value) {
              selectedDataChildren = aeThis.filterContactAffiliationOnclick(contactRealtedFrom, contactRelatedTo, contactToAccount);
            } else {
              selectedDataChildren = aeThis.formatAffiliationDataFromContactRelationship(contactRelatedTo, contactRealtedFrom, contactToAccount);
            }
          }
        }
        if (!isEmpty(selectedDataChildren)) {
          selectedDataChildren.forEach(d => {
            d.name = d.name && d.name.length > 20 ? d.name.substring(0, 20).concat("...") : d.name;
          });
          selected.children = selectedDataChildren;
          if (selected.parent) {
            selected.parent.children.forEach(e => {
              if (selected !== e) collapse(e);
            });
          }
        }
      } else {
        selected.children = null;
      }
      update(selected);
    }

    function tooltipPopOver(d, pageX, pageY) {
      tooltip.style("opacity", 1);
      tooltip.style("z-index", 10000);
      let relationshipContactText;
      let previewText = aeThis.translate.instant('PREVIEW');
      let affiliationSourceTypeText = aeThis.translate.instant('AFFILIATION_SOURCE_TYPE');
      if (aeThis.from === "ContactPageComponent") {
        if (d.type == "contact") {
          relationshipContactText = aeThis.translate.instant('RELATIONSHIP');
        } else {
          relationshipContactText = aeThis.translate.instant('AFFILIATION_ROLE');
        }
      } else if (aeThis.from === "AccountPageComponent") {
        if (d.type == "contact") {
          relationshipContactText = aeThis.translate.instant('AFFILIATION_ROLE');
        } else {
          relationshipContactText = aeThis.translate.instant('AFFILIATION_TYPE');
        }
      }
      tooltip
        .html(
          d.type == "contact" ?
            `<table  style='font-size: 13px; border-collapse: separate; color : #0D0D0D' >
              <tr id="relationship" class="border-bottom">
                <td style="color:#737373">${relationshipContactText}</td>
                <td style="color:#000000" class = "text-right">${d.relationship == null || d.relationship == 'None' ? '' : d.relationship}</td>
              <tr>
              <tr id = "affiliationSourceType" class="border-bottom">
                <td style="color:#737373">${d.affiliationSourceType == undefined || d.affiliationSourceType == 'None' ? '' : `${affiliationSourceTypeText}`} </td>
                <td style="color:#000000" class = "text-right">${d.affiliationSourceType == undefined || d.affiliationSourceType == 'None' ? '' : d.affiliationSourceType}</td></tr>
              <tr  id="preview"><td style="color : #007AFF"> ${previewText} ${d.type}</td>
                <td class = "text-right"><i class="arrow right"></i></td>
              </tr>
          </table>` : d.type=="account"?
            `<table  style='font-size: 13px; border-collapse: separate; color : #0D0D0D' >
            <tr id="affiliationRole" class="border-bottom" >
              <td style="color:#737373">${relationshipContactText}</td>
              <td style="color:#000000" class ="text-right">${d.affiliationRole == undefined || d.affiliationRole == 'None' ? '' : d.affiliationRole}</td>
            </tr>
            <tr id="affiliationSourceType" class="border-bottom">
              <td style="color:#737373">${d.affiliationSourceType == undefined || d.affiliationSourceType == 'None' ? '' : `${affiliationSourceTypeText}`}</td>
              <td style="color:#000000" class ="text-right">${d.affiliationSourceType == undefined || d.affiliationSourceType == 'None' ? '' : d.affiliationSourceType}</td>
            </tr>
            <tr id="preview">
              <td style="color : #007AFF"> ${previewText} ${d.type}</td>
              <td  class = "text-right"><i class="arrow right "></i></td>
            </tr>
          </table>`:null)
        .style("left", `${d.x + 20}px`)
        .style("top", `${d.y}px`)
        .style('left', `${pageX - 100}px`)
        .style('top', `${pageY + 25}px`)
        .style("opacity", 1)
      if (!d.affiliationRole) {
        d3.select("#affiliationRole").style('display', 'none')
      }
      if (!d.relationship || d.relationship == 'None') {
        d3.select("#relationship").style('display', 'none')
      }
      if (!d.affiliationSourceType) {
        d3.select("#affiliationSourceType").style('display', 'none')
      }
      if (!d.type) {
        d3.select(".preview").style('display', 'none')
      }
      d3.select("#preview").on("click", async () => {
        tooltip
          .style("opacity", 0)
        tooltip.style("z-index", 10000);
        if (d.type === 'account') {
          aeThis.openAccountDetails(d.entity_id);
        } else {
          aeThis.openContactDetails(d.entity_id);
        }

      });
    }
  }

  private async openAccountDetails(accountId: string) {
    let account: Account = this.accountOfflineService.getAccountById(accountId);
    if (!account) {
      //if FA for Global Search is mapped to current user, fetch account in read only mode
      if(this.authenticationService.hasFeatureAction(FeatureActionsMap.ACCOUNT_GLOBAL_SEARCH)){
        //Helps to avoid navigation loops
        //if (this.contactOfflineService.accessedContactListFrom === PageName.AccountDetailsComponent && this.contactOfflineService.contactPageMode === ComponentViewMode.PREVIEW) return;
        //if (this.dynamicFormService.isOpenedAffiliatedAccountOnAccount && this.navService.getCurrentMasterPageName() == PageName.AccountPageComponent) return;
        if(this.device.isOffline){
          const targetText = this.translate.instant("ACCOUNT");
          this.notificationService.notify(this.translate.instant('PREVIEW_UNAVAILABLE_NEED_TO_BE_ONLINE', {text: targetText}), 'Account Details', 'top', ToastStyle.INFO);
        } 
        else{
          try{
            this.uiService.displayLoader();
            this.accountOfflineService.isNotInMyAccountList = true;
            const rawDetails = await this.accountDataService.getRealTimeAccountDetailsOnline(accountId,true);
            if (rawDetails) {
              const foundAccount = new Account(rawDetails);
              this.uiService.dismissLoader();
              this.notificationService.notify(this.translate.instant('ACCOUNT_NOT_IN_YOUR_LIST'), 'Account list', 'top', ToastStyle.INFO, 3000);
              if (foundAccount){
                await this.accountOfflineService.setErrorMessageOpenAccount();
                this._resetFlagOpenedAffiliatedDataDetails();
                this.dynamicFormService.openedUnmappedData = true;
                this.uiService.showNewActivity = false;
                this.uiService.activeView = 'accountDetails';
                this.uiService.isForcedHideGoToToolBtn = this.accountOfflineService.accountPageMode == ComponentViewMode.ADDNEW || this.accountOfflineService.accountPageMode == ComponentViewMode.SELECTION;
                this.accountOfflineService.accountPrevPageMode = this.accountOfflineService.accountPageMode;
                this.accountOfflineService.accountPageMode = ComponentViewMode.PREVIEW;
                if (this.navService.getCurrentMasterPageName() === PageName.AccountPageComponent) {
                  // this.navService.popChildNavPageWithPageTracking();
                  this.dynamicFormService.isOpenedAffiliatedAccountOnAccount = true;
                  if (this.accountOfflineService.selected) this.accountOfflineService.prevSelected = this.accountOfflineService.selected;
                  this.accountOfflineService.selected = foundAccount;
                  this.footerService.initButtons(FooterViews.Accounts);
                  //this.events.publish('highlightAccount', foundAccount);
                  this.navService.pushChildNavPageWithPageTracking(PageName.AccountDetailsComponent, PageName.AccountDetailsComponent, PageName.AccountPageComponent, { listMode: ComponentViewMode.READONLY });
                } else{
                  this.dynamicFormService.isOpenedAffiliatedAccountOnContact = true; 
                  this.accountOfflineService.accessedAccountListFrom = PageName.ContactDetailsComponent;
                  this.accountOfflineService.selected = foundAccount;
                  this.footerService.initButtons(FooterViews.Accounts);
                  this.navService.pushChildNavPageWithPageTracking(PageName.AccountDetailsComponent, PageName.ContactDetailsComponent, PageName.ContactPageComponent, { listMode: ComponentViewMode.READONLY });
                }
              }
            } else {
              this.uiService.dismissLoader();
              this.notificationService.notify(this.translate.instant('PREVIEW_UNAVAILABLE'), 'Account Details', 'top', ToastStyle.INFO);
            }
          } catch(err){
            console.log( "Error in fetching unmapped account information"+ err);
            this.uiService.dismissLoader();
          }
        }
      }
      else{
        this.notificationService.notify(this.translate.instant('ACCOUNT_NO_ACCESS_CONTACT_ADMIN'), 'Account list', 'top', ToastStyle.DANGER);
        return;
      }
      //this.notificationService.notify(this.translate.instant('ACCOUNT_NO_LONGER_ACCESS'), 'Account list', 'top', ToastStyle.DANGER);
      //return;
    }
    else{
      //this.uiService.accountDataSegment = 'info';
      this.accountOfflineService.accountPageMode = ComponentViewMode.READONLY;
      if (this.accountOfflineService.selected) this.accountOfflineService.prevSelected = this.accountOfflineService.selected;
      this.accountOfflineService.selected = account;
      //this.accountDataService.getAccountTimelineInfo(account);
      if (this.navService.getCurrentMasterPageName() === PageName.AccountPageComponent) {
        this.dynamicFormService.isOpenedAffiliatedAccountOnAccount = true;
        this.footerService.initButtons(FooterViews.Accounts);
        //this.events.publish('highlightAccount', foundAccount);
        this.navService.pushChildNavPageWithPageTracking(PageName.AccountDetailsComponent, PageName.AccountDetailsComponent, PageName.AccountPageComponent, { listMode: ComponentViewMode.READONLY });

        // this.navService.popChildNavPageWithPageTracking();
        // this.dynamicFormService.isOpenedAffiliatedAccountOnAccount = true;
        // this.events.publish('highlightAccount', account);
      } else {
        this.dynamicFormService.isOpenedAffiliatedAccountOnContact = true;
        this.accountOfflineService.accessedAccountListFrom = PageName.ContactDetailsComponent;
        this.navService.pushChildNavPageWithPageTracking(PageName.AccountDetailsComponent, PageName.ContactDetailsComponent, PageName.ContactPageComponent, { listMode: this.accountOfflineService.accountPageMode });
      }
    }
  }

  private async openContactDetails(contactId: string) {
    let contact: Contact = this.contactOfflineService.getContactByID(contactId);
    if (!contact) {
      //if FA for Global Search is mapped to current user, fetch contact in read only mode
      if(this.authenticationService.hasFeatureAction(FeatureActionsMap.CONTACTS_GLOBAL_SEARCH)){
        //Helps to avoid navigation loop in case of contact on contact
        //if (this.dynamicFormService.isOpenedAffiliatedContactOnContact && this.navService.getCurrentMasterPageName() == PageName.ContactPageComponent) return;
        if(this.device.isOffline){
          const targetText = this.translate.instant("CONTACT_SINGULAR");
          this.notificationService.notify(this.translate.instant('PREVIEW_UNAVAILABLE_NEED_TO_BE_ONLINE', {text: targetText}), 'Contact Details', 'top', ToastStyle.INFO);
        }
        else{
          try{
            this.uiService.displayLoader();
            this.contactOfflineService.isNotInMyContactList = true;
            const rawDetails =  await this.contactOfflineService.fetchContactsForConfiguredDisplay(true, false, contactId, true);
            if (rawDetails && rawDetails[0]) {
              const foundContact = new Contact(rawDetails[0]);
              this.contactOfflineService.isInGlobalSearch = false;
              this.uiService.dismissLoader();
              this.notificationService.notify(this.translate.instant('CONTACT_NOT_IN_YOUR_LIST'), 'Contact list', 'top', ToastStyle.INFO, 3000);
              if (foundContact) {
                await this.contactOfflineService.setErrorMessageOpenContact();
                this._resetFlagOpenedAffiliatedDataDetails();
                this.dynamicFormService.openedUnmappedData = true;
                if (this.navService.getCurrentMasterPageName() === PageName.AccountPageComponent) {
                this.dynamicFormService.isOpenedAffiliatedContactOnAccount = true;
                this.dynamicFormService.isNavAffiliatedContactFromAccount = false;
                this.contactOfflineService.contactInformation = foundContact;
                this.uiService.isForcedHideGoToToolBtn = this.contactOfflineService.contactPageMode == ComponentViewMode.ADDNEW || this.contactOfflineService.contactPageMode == ComponentViewMode.SELECTION;
                this.contactOfflineService.contactPrevPageMode = this.contactOfflineService.contactPageMode;
                this.contactOfflineService.contactPageMode = ComponentViewMode.PREVIEW;
                this.contactOfflineService.accessedContactListFrom = PageName.AccountDetailsComponent;
                this.footerService.initButtons(FooterViews.Contacts);
                this.navService.pushChildNavPageWithPageTracking(PageName.ContactDetailsComponent, PageName.AccountDetailsComponent, PageName.AccountPageComponent, { contactListMode: ComponentViewMode.READONLY });
                } else {
                  this.dynamicFormService.isOpenedAffiliatedContactOnContact = true;
                  if (this.contactOfflineService.contactInformation) this.contactOfflineService.prevSelected = this.contactOfflineService.contactInformation;
                  this.uiService.showNewActivity = false;
                  this.uiService.isForcedHideGoToToolBtn = this.contactOfflineService.contactPageMode == ComponentViewMode.ADDNEW || this.contactOfflineService.contactPageMode == ComponentViewMode.SELECTION;
                  this.contactOfflineService.contactPrevPageMode = this.contactOfflineService.contactPageMode;
                  this.contactOfflineService.contactPageMode = ComponentViewMode.PREVIEW;
                  this.footerService.initButtons(FooterViews.Contacts);
                  // this.events.publish('highlightAffiliatedContact', foundContact);
                  this.contactOfflineService.contactInformation = foundContact;
                  this.navService.pushChildNavPageWithPageTracking(PageName.ContactDetailsComponent, PageName.ContactDetailsComponent, PageName.ContactPageComponent, { contactListMode: ComponentViewMode.READONLY });
                }
              }
            } else {
              this.uiService.dismissLoader();
              this.notificationService.notify(this.translate.instant('PREVIEW_UNAVAILABLE'), 'Contact Details', 'top', ToastStyle.INFO);
            }
          } catch(err){
            console.log( "Error in fetching unmapped contact information"+ err);
            this.uiService.dismissLoader();
          }
        }
      }
      else{
        this.notificationService.notify(this.translate.instant('CONTACT_NO_ACCESS_CONTACT_ADMIN'), 'Contact list', 'top', ToastStyle.DANGER);
        return;
      }
      //this.notificationService.notify(this.translate.instant('CONTACT_NO_LONGER_ACCESS'), 'Contact list', 'top', ToastStyle.DANGER);
      //return;
    }
    else {
      //this._resetFlagOpenedAffiliatedDataDetails();
      if (this.navService.getCurrentMasterPageName() === PageName.AccountPageComponent) {
        this.dynamicFormService.isOpenedAffiliatedContactOnAccount = true;
        this.dynamicFormService.isNavAffiliatedContactFromAccount = false;
        this.contactOfflineService.contactInformation = contact;
        //this.uiService.contactDetailsSegment = 'info';
        //this.uiService.isForcedHideGoToToolBtn = this.contactOfflineService.contactPageMode == ComponentViewMode.ADDNEW || this.contactOfflineService.contactPageMode == ComponentViewMode.SELECTION;
        //this.contactOfflineService.contactPrevPageMode = this.contactOfflineService.contactPageMode;   
        this.contactOfflineService.contactPageMode = ComponentViewMode.READONLY;
        this.contactOfflineService.accessedContactListFrom = PageName.AccountDetailsComponent;
        this.navService.pushChildNavPageWithPageTracking(PageName.ContactDetailsComponent, PageName.AccountDetailsComponent, PageName.AccountPageComponent, { contactListMode: ComponentViewMode.READONLY });
      } else {
        this.dynamicFormService.isOpenedAffiliatedContactOnContact = true;
        //if (this.contactOfflineService.contactInformation) this.contactOfflineService.prevSelected = this.contactOfflineService.contactInformation;
        //this.uiService.showNewActivity = false;
        //this.uiService.isForcedHideGoToToolBtn = this.contactOfflineService.contactPageMode == ComponentViewMode.ADDNEW || this.contactOfflineService.contactPageMode == ComponentViewMode.SELECTION;
        //this.contactOfflineService.contactPrevPageMode = this.contactOfflineService.contactPageMode;
        //this.contactOfflineService.contactPageMode = ComponentViewMode.PREVIEW;
        // this.events.publish('highlightContact', contact);
        if (this.contactOfflineService.contactInformation) this.contactOfflineService.prevSelected = this.contactOfflineService.contactInformation;
        this.contactOfflineService.contactInformation = contact;
        this.navService.pushChildNavPageWithPageTracking(PageName.ContactDetailsComponent, PageName.ContactDetailsComponent, PageName.ContactPageComponent, { contactListMode: ComponentViewMode.READONLY });
        this.footerService.initButtons(FooterViews.Contacts);
      }
    }
  }

  private _resetFlagOpenedAffiliatedDataDetails() {
    this.dynamicFormService.isOpenedAffiliatedContactOnAccount = false;
    this.dynamicFormService.isOpenedAffiliatedAccountOnAccount = false;
    this.dynamicFormService.isOpenedAffiliatedAccountOnContact = false;
    this.dynamicFormService.isOpenedAffiliatedContactOnContact = false;
  }

  private formatAffiliationDataFromContactRelationship(contactRelatedTo, contactRelatedFrom, contactToAccount) {
    let contactAffData: AffilitionData[] = [];
    if (!isEmpty(contactRelatedTo)) {
      const mainAttribute = "indskr_contactrelationship";

      contactRelatedTo.forEach(element => {
        if (element[`${mainAttribute}.statecode`] === 0 
            && (element[`${mainAttribute}.indskr_relatedcontactid_Formatted`] || element[`${mainAttribute}.indskr_relatedcontactid@OData.Community.Display.V1.FormattedValue`])) {
          const id = element[`${mainAttribute}.indskr_relatedcontactid`];
          const formattedName = element[`${mainAttribute}.indskr_relatedcontactid_Formatted`] 
            || element[`${mainAttribute}.indskr_relatedcontactid@OData.Community.Display.V1.FormattedValue`];
          const sourceType = element[`${mainAttribute}.indskr_relationshipsourcetype_Formatted`] 
            || element[`${mainAttribute}.indskr_relationshipsourcetype@OData.Community.Display.V1.FormattedValue`];
          const relationship = element[`${mainAttribute}.indskr_relationship_Formatted`] 
            || element[`${mainAttribute}.indskr_relationship@OData.Community.Display.V1.FormattedValue`]
            || element[`${mainAttribute}.omnione_relationship_Formatted`] 
            || element[`${mainAttribute}.omnione_relationship@OData.Community.Display.V1.FormattedValue`];
          const iconPath = 'assets/imgs/contact-affiliation.svg';

          contactAffData.push(new AffilitionData(id,"contact",formattedName,100,'#007AFF','#0361CA',null,sourceType,null,relationship,iconPath));
        }
      });
    }
    if (!isEmpty(contactRelatedFrom)) {
      const mainAttribute = "indskr_contactrelationship";
      
      contactRelatedFrom.forEach(element => {
        if (element[`${mainAttribute}.statecode`] === 0 
            && (element[`${mainAttribute}.indskr_contactid_Formatted`] || element[`${mainAttribute}.indskr_contactid@OData.Community.Display.V1.FormattedValue`])) {
          const id = element[`${mainAttribute}.indskr_contactid`];
          const formattedName = element[`${mainAttribute}.indskr_contactid_Formatted`] || element[`${mainAttribute}.indskr_contactid@OData.Community.Display.V1.FormattedValue`];
          const sourceType = element[`${mainAttribute}.indskr_relationshipsourcetype_Formatted`] 
            || element[`${mainAttribute}.indskr_relationshipsourcetype@OData.Community.Display.V1.FormattedValue`];
          const relationship = element[`${mainAttribute}.indskr_relationship_Formatted`] 
            || element[`${mainAttribute}.indskr_relationship@OData.Community.Display.V1.FormattedValue`] 
            || element[`${mainAttribute}.omnione_relationship_Formatted`] 
            || element[`${mainAttribute}.omnione_relationship@OData.Community.Display.V1.FormattedValue`];
          const iconPath = 'assets/imgs/contact-affiliation.svg';

          contactAffData.push(new AffilitionData(id,"contact",formattedName,100,'#007AFF','#0361CA',null,sourceType,null,relationship,iconPath));
        }
      });
    }
    if (!isEmpty(contactToAccount)) {
      const mainAttribute = "indskr_accountcontactaffiliation";
      
      contactToAccount.forEach(element => {
        if (element[`${mainAttribute}.statecode`] === 0 
            && (element[`${mainAttribute}.indskr_accountid_Formatted`] || element[`${mainAttribute}.indskr_accountid@OData.Community.Display.V1.FormattedValue`])) {
          const id = element[`${mainAttribute}.indskr_accountid`];
          const formattedName = element[`${mainAttribute}.indskr_accountid_Formatted`] 
            || element[`${mainAttribute}.indskr_accountid@OData.Community.Display.V1.FormattedValue`];
          const role = element[`${mainAttribute}.omnione_role_Formatted`] 
            || element[`${mainAttribute}.omnione_role@OData.Community.Display.V1.FormattedValue`] 
            || element[`${mainAttribute}.omnione_lu_affiliationrole_Formatted`] 
            || element[`${mainAttribute}.omnione_lu_affiliationrole@OData.Community.Display.V1.FormattedValue`];
          const sourceType = element[`${mainAttribute}.indskr_affiliationsourcetype_Formatted`] 
            || element[`${mainAttribute}.indskr_affiliationsourcetype@OData.Community.Display.V1.FormattedValue`];
          const iconPath = 'assets/imgs/account-affiliation.svg';

          contactAffData.push(new AffilitionData(id,"account",formattedName,100,'#E64969','#BF1D3E',role,sourceType,null,null,iconPath));
        }
      });
    }
    return uniqBy(contactAffData, 'entity_id');
  }

  /**
   * The affiliation entities this form may show past the rep's position, from
   * BU_AFFILIATION_GA_VISIBILITY. Empty means the org has not opted in and nothing changes.
   */
  private _beyondPositionRefEntities(): string[] {
    const visibility = this.authenticationService.getAffiliationVisibility();
    const want: string[] = [];
    if (this.from === 'AccountPageComponent') {
      if (visibility.accountForm.affiliatedAccountsOnline === 'all') want.push(ACCOUNT_ACCOUNT_AFFILIATIONS_REF_ENTITY);
      if (visibility.accountForm.affiliatedContactsOnline === 'all') want.push(ACCOUNT_CONTACT_AFFILIATIONS_REF_ENTITY);
    } else if (this.from === 'ContactPageComponent') {
      if (visibility.contactForm.affiliatedAccountsOnline === 'all') want.push(ACCOUNT_CONTACT_AFFILIATIONS_REF_ENTITY);
    }
    return want;
  }

  /**
   * Rebuilds the root's children from the same beyond-position rows the display form shows,
   * so opening the Explorer does not contradict the Info tab it was opened from.
   *
   * Prefers the rows the display form already fetched and left on the selected record, so the
   * common path costs no request and is identical to what the rep just saw; only falls back to
   * a fetch when the Explorer was reached another way (e.g. the timeline page).
   *
   * Only the entity types the config enables are replaced - the rest keep the position-scoped
   * rows passed in by the host, so an org enabling one list does not silently get the other.
   */
  /**
   * The rows the root is drawn from: the display form's beyond-position rows when it has
   * already fetched them for this account, else the position-scoped inputs from the host.
   *
   * Resolved synchronously so the first paint already agrees with the Info tab. Rebuilding
   * afterwards would show the rep a pruned tree and then change it under them.
   */
  /**
   * The contact's account affiliations for the root: the display form's beyond-position rows
   * when it fetched them, else the position-scoped input. Contact-contact rows are not
   * covered - they are governed by their own keys.
   */
  /**
   * Affiliations for an expanded contact node: the position-scoped rows, with the contact's
   * ACCOUNT affiliations replaced by their beyond-position equivalents when the org has
   * opted in. Contact-to-contact rows keep the local set - they are governed by their own
   * keys, which have no beyond-position option, so the live list must not leak them in.
   */
  private async _contactRelationshipData(contactId: string): Promise<any> {
    const local = {
      contactRelatedTo: await this.contactOfflineService.getContactRelatedToByContactId(contactId),
      contactRealtedFrom: await this.contactOfflineService.getContactRelatedFromByContactId(contactId),
      contactToAccount: await this.contactOfflineService.getContactToAccountByContactId(contactId),
    };
    if (!this._beyondPositionRefEntities().length || this.device.isOffline) return local;
    const live = await this.contactOfflineService.fetchUnmappedContactsLinkedEntityData(contactId);
    // null means offline or the request failed - keep what local storage gave us.
    if (!live) return local;
    return { ...local, contactToAccount: live['contactToAccount'] ?? local.contactToAccount };
  }

  /** Whether a node's record sits outside the rep's position; drives the dashed link. */
  public _isOutsidePosition(node: any): boolean {
    if (!node?.entity_id) return false;
    if (node.type === 'account') return !this.accountOfflineService.getAccountById(node.entity_id);
    if (node.type === 'contact') return !this.contactOfflineService.getContactByID(node.entity_id);
    return false;
  }

  private _contactRootAccountRows(): any {
    const published = this.contactOfflineService.getBeyondPositionAffiliations(this.parent?.ID);
    return published[ACCOUNT_CONTACT_AFFILIATIONS_REF_ENTITY] ?? this.contactAccountAffiliation;
  }

  private _rootAffiliationRows(): { relatedTo: any, relatedFrom: any, accountContact: any } {
    const fallback = { relatedTo: this.relatedTo, relatedFrom: this.relatedFrom, accountContact: this.contactAccountAffiliation };
    const published = this.accountOfflineService.getBeyondPositionAffiliations(this.parent?.id);
    if (!Object.keys(published).length) return fallback;
    const prefix = DB_KEY_PREFIXES.ACCOUNT_LINKED_ENTITY;
    return {
      relatedTo: published[prefix + 'indskr_account_accountaccountaffiliation_affiliatedtoaccountid'] ?? fallback.relatedTo,
      relatedFrom: published[prefix + 'indskr_account_accountaccountaffiliation_affiliatedfromaccountid'] ?? fallback.relatedFrom,
      accountContact: published[prefix + ACCOUNT_CONTACT_AFFILIATIONS_REF_ENTITY] ?? fallback.accountContact,
    };
  }

  private async _refreshContactRootBeyondPosition(): Promise<void> {
    if (this.from !== 'ContactPageComponent' || this.device.isOffline) return;
    if (!this._beyondPositionRefEntities().length) return;
    const contactId = this.parent?.ID;
    if (!contactId) return;
    // Already drawn from the display form's rows - refetching would only risk disagreeing.
    if (Object.keys(this.contactOfflineService.getBeyondPositionAffiliations(contactId)).length) return;
    const live = await this.contactOfflineService.fetchUnmappedContactsLinkedEntityData(contactId);
    if (!live || !live['contactToAccount'] || !this.data) return;
    this.data.children = this.formatAffiliationDataFromContactRelationship(
      this.relatedTo, this.relatedFrom, live['contactToAccount']);
    this.data.children?.forEach(d => d.name = d.name && d.name.length > 20 ? d.name.substring(0, 20).concat('...') : d.name);
    this.source = cloneDeep(this.data);
    this.renderChart();
  }

  private async _refreshRootBeyondPosition(): Promise<void> {
    const want = this._beyondPositionRefEntities();
    if (!want.length || this.from !== 'AccountPageComponent' || this.device.isOffline) return;
    // Already drawn from the display form's rows - refetching would only risk disagreeing.
    if (Object.keys(this.accountOfflineService.getBeyondPositionAffiliations(this.parent?.id)).length) return;
    const accountId = this.parent?.id;
    if (!accountId) return;

    let relatedTo = this.relatedTo;
    let relatedFrom = this.relatedFrom;
    let accountContact = this.contactAccountAffiliation;
    let changed = false;

    const live = await this.accountDataService.fetchUnmappedAccountsLinkedEntityData(accountId, want);
    if (!live) return;
    if (want.includes(ACCOUNT_ACCOUNT_AFFILIATIONS_REF_ENTITY)) {
      relatedTo = live.linkEntityAccountTo ?? relatedTo;
      relatedFrom = live.linkEntityAccountFrom ?? relatedFrom;
      changed = true;
    }
    if (want.includes(ACCOUNT_CONTACT_AFFILIATIONS_REF_ENTITY)) {
      accountContact = live.linkedAccountContact ?? accountContact;
      changed = true;
    }
    if (!changed || !this.data) return;

    this.data.children = this.formatAffiliationDataFromAccountRelationship(
      relatedTo, relatedFrom, accountContact, this.accountToBrand);
    this.data.children?.forEach(d => d.name = d.name && d.name.length > 20 ? d.name.substring(0, 20).concat('...') : d.name);
    this.source = cloneDeep(this.data);
    this.renderChart();
  }

  /**
   * Affiliations for an expanded account node: the position-scoped rows, with the entity
   * types the config opens up replaced by their beyond-position equivalents.
   *
   * The branch above already does this for nodes the rep does not own; without this, nodes
   * the rep DOES own stayed pruned, so the tree contradicted itself depending on whose
   * account you expanded. Types the config leaves off keep the position-scoped rows, so an
   * org enabling one list does not silently get the other.
   */
  private async _accountRelationshipData(accountId: string): Promise<any> {
    const local = await this.accountOfflineService.getAccountRelationshipById(accountId, true);
    const want = this._beyondPositionRefEntities();
    if (!want.length || this.device.isOffline) return local;
    const live = await this.accountDataService.fetchUnmappedAccountsLinkedEntityData(accountId, want);
    // null means offline or the request failed - keep what local storage gave us.
    if (!live) return local;
    const wantsAA = want.includes(ACCOUNT_ACCOUNT_AFFILIATIONS_REF_ENTITY);
    const wantsAC = want.includes(ACCOUNT_CONTACT_AFFILIATIONS_REF_ENTITY);
    return {
      linkEntityAccountTo: wantsAA ? live.linkEntityAccountTo : local?.linkEntityAccountTo,
      linkEntityAccountFrom: wantsAA ? live.linkEntityAccountFrom : local?.linkEntityAccountFrom,
      linkedAccountContact: wantsAC ? live.linkedAccountContact : local?.linkedAccountContact,
      brandAffiliationByAccountId: local?.brandAffiliationByAccountId,
    };
  }

  private formatAffiliationDataFromAccountRelationship(accountRelatedTo, accountRelatedFrom, accountToContact, accountToBrand) {
    let accountAffData: AffilitionData[] = [];
    if (!isEmpty(accountRelatedTo)) {
      const mainAttribute = "indskr_accountaccountaffiliation";

      accountRelatedTo.forEach(element => {
        if (element[`${mainAttribute}.statecode`] === 0 
          && (element[`${mainAttribute}.indskr_affiliatedfromaccountid_Formatted`] || element[`${mainAttribute}.indskr_affiliatedfromaccountid@OData.Community.Display.V1.FormattedValue`])) {
          const id = element[`${mainAttribute}.indskr_affiliatedfromaccountid`];
          const formattedName = element[`${mainAttribute}.indskr_affiliatedfromaccountid_Formatted`] 
            || element[`${mainAttribute}.indskr_affiliatedfromaccountid@OData.Community.Display.V1.FormattedValue`];
          const affiliationType = element[`${mainAttribute}.omnione_relationship_Formatted`] 
            || element[`${mainAttribute}.omnione_lu_affiliationtype_Formatted`] 
            || element[`${mainAttribute}.omnione_relationship@OData.Community.Display.V1.FormattedValue`] 
            || element[`${mainAttribute}.omnione_lu_affiliationtype@OData.Community.Display.V1.FormattedValue`];
          const sourceType = element[`${mainAttribute}.indskr_affiliationsourcetype_Formatted`] 
            || element[`${mainAttribute}.indskr_affiliationsourcetype@OData.Community.Display.V1.FormattedValue`];
          const iconPath = 'assets/imgs/account-affiliation.svg';

          accountAffData.push(new AffilitionData(id, "account", formattedName, 100, '#E64969', '#BF1D3E',affiliationType, sourceType, null, null, iconPath));
        }
      });
    }
    if (!isEmpty(accountRelatedFrom)) {
      const mainAttribute = "indskr_accountaccountaffiliation";

      accountRelatedFrom.forEach(element => {
        if (element[`${mainAttribute}.statecode`] === 0 
          && (element[`${mainAttribute}.indskr_affiliatedtoaccountid_Formatted`] || element[`${mainAttribute}.indskr_affiliatedtoaccountid@OData.Community.Display.V1.FormattedValue`])) {
          const id = element[`${mainAttribute}.indskr_affiliatedtoaccountid`];
          const formattedName = element[`${mainAttribute}.indskr_affiliatedtoaccountid_Formatted`] 
            || element[`${mainAttribute}.indskr_affiliatedtoaccountid@OData.Community.Display.V1.FormattedValue`];
          const affiliationType = element[`${mainAttribute}.omnione_relationship_Formatted`] 
            || element[`${mainAttribute}.omnione_lu_affiliationtype_Formatted`] 
            || element[`${mainAttribute}.omnione_relationship@OData.Community.Display.V1.FormattedValue`] 
            || element[`${mainAttribute}.omnione_lu_affiliationtype@OData.Community.Display.V1.FormattedValue`];
          const sourceType = element[`${mainAttribute}.indskr_affiliationsourcetype_Formatted`] 
            || element[`${mainAttribute}.indskr_affiliationsourcetype@OData.Community.Display.V1.FormattedValue`];
          const iconPath = 'assets/imgs/account-affiliation.svg';

          accountAffData.push(new AffilitionData(id, "account", formattedName, 100, '#E64969', '#BF1D3E',affiliationType, sourceType, null, null, iconPath));
        }
      });
    }
    if (!isEmpty(accountToContact)) {
      const mainAttribute = "indskr_accountcontactaffiliation";

      accountToContact.forEach(element => {
        if (element[`${mainAttribute}.statecode`] === 0 
          && (element[`${mainAttribute}.indskr_contactid_Formatted`] || element[`${mainAttribute}.indskr_contactid@OData.Community.Display.V1.FormattedValue`])) {
          const id = element[`${mainAttribute}.indskr_contactid`];
          const formattedName = element[`${mainAttribute}.indskr_contactid_Formatted`] 
            || element[`${mainAttribute}.indskr_contactid@OData.Community.Display.V1.FormattedValue`];
          const sourceType = element[`${mainAttribute}.indskr_affiliationsourcetype_Formatted`] 
            || element[`${mainAttribute}.indskr_affiliationsourcetype@OData.Community.Display.V1.FormattedValue`];
          const role = element[`${mainAttribute}.indskr_contactrole_Formatted`]
            || element[`${mainAttribute}.indskr_contactrole@OData.Community.Display.V1.FormattedValue`] 
            || element[`${mainAttribute}.omnione_role_Formatted`] 
            || element[`${mainAttribute}.omnione_role@OData.Community.Display.V1.FormattedValue`];
          const iconPath = 'assets/imgs/contact-affiliation.svg';

          accountAffData.push(new AffilitionData(id, "contact", formattedName, 100, '#007AFF', '#0361CA',null, sourceType, null, role, iconPath));
        }
      });
    }
    if (!isEmpty(accountToBrand)) {
      const mainAttribute = "indskr_accountbrandaffiliation";
      
      accountToBrand.forEach(element => {
        if (element[`${mainAttribute}.statecode`] === 0 
            && (element[`${mainAttribute}.indskr_affiliatedtoid_Formatted`] || element[`${mainAttribute}.indskr_affiliatedtoid@OData.Community.Display.V1.FormattedValue`])) {
          const id = element[`${mainAttribute}.indskr_accountbrandaffiliationid`];
          const formattedName = element[`${mainAttribute}.indskr_affiliatedtoid_Formatted`] 
            || element[`${mainAttribute}.indskr_affiliatedtoid@OData.Community.Display.V1.FormattedValue`];
          const iconPath = "assets/imgs/brand-affiliation.svg";
          
          accountAffData.push(new AffilitionData(id, "brand", formattedName, 100, '#42d77d', '#28ba62', null, null, null, null, iconPath));
        }
      });
    }
    return uniqBy(accountAffData, 'entity_id');
  }

  initFilterHeader() {
    const sortButton = []
    sortButton.push({
      id: 'affilitionType-sort',
      text: this.filterByDisplay ? this.filterByDisplay : '',
      isDisabled: false,
      img: "assets/imgs/sort_with_double_arrows.svg",
    });
    this.affiliationFilterViewData = {
      id: 'all-contacts-header',
      title: this.translate.instant("ALL_AFFILIATIONS"),
      controls: sortButton
    };
  }

  affiliationFilter(treeData, slectedFilterValue:string[], selectedSourceTypeFilterValue:string) {
    console.log(slectedFilterValue);
    let affiliationData = [];
    let relatedFromData = this.relatedFrom;
    let relatedToData = this.relatedTo;
    let brandData = []
    treeData.children = [];
    if (this.from === "AccountPageComponent") {
      affiliationData = this.contactAccountAffiliation;
      brandData = this.accountToBrand;
    } else if (this.from === "ContactPageComponent") {
      affiliationData = this.contactAccountAffiliation;
      brandData = [];
    }

    if (selectedSourceTypeFilterValue !== 'all') {
      affiliationData = affiliationData.filter((element) => {
        if (element["indskr_accountcontactaffiliation.indskr_affiliationsourcetype_Formatted"]) {
          return element["indskr_accountcontactaffiliation.indskr_affiliationsourcetype_Formatted"] == selectedSourceTypeFilterValue;
        } else if (element["indskr_accountcontactaffiliation.indskr_affiliationsourcetype@OData.Community.Display.V1.FormattedValue"]) {
          return element["indskr_accountcontactaffiliation.indskr_affiliationsourcetype@OData.Community.Display.V1.FormattedValue"] == selectedSourceTypeFilterValue;
        } else {
          return false;
        }
      });

      relatedFromData = relatedFromData.filter((element) => {
        if (element['indskr_accountaccountaffiliation.indskr_affiliationsourcetype_Formatted']) {
          return element['indskr_accountaccountaffiliation.indskr_affiliationsourcetype_Formatted'] == selectedSourceTypeFilterValue;
        } else if (element['indskr_accountaccountaffiliation.indskr_affiliationsourcetype@OData.Community.Display.V1.FormattedValue']) {
          return element['indskr_accountaccountaffiliation.indskr_affiliationsourcetype@OData.Community.Display.V1.FormattedValue'] == selectedSourceTypeFilterValue;
        } else {
          return false;
        }
      });

      relatedToData = relatedToData.filter((element) => {
        if (element['indskr_accountaccountaffiliation.indskr_affiliationsourcetype_Formatted']) {
          return element['indskr_accountaccountaffiliation.indskr_affiliationsourcetype_Formatted'] == selectedSourceTypeFilterValue;
        } else if (element['indskr_accountaccountaffiliation.indskr_affiliationsourcetype@OData.Community.Display.V1.FormattedValue']) {
          return element['indskr_accountaccountaffiliation.indskr_affiliationsourcetype@OData.Community.Display.V1.FormattedValue'] == selectedSourceTypeFilterValue;
        } else if (element["indskr_contactrelationship.indskr_relationshipsourcetype_Formatted"]) {
          return element["indskr_contactrelationship.indskr_relationshipsourcetype_Formatted"] == selectedSourceTypeFilterValue;
        } else if (element["indskr_contactrelationship.indskr_relationshipsourcetype@OData.Community.Display.V1.FormattedValue"]) {
          return element["indskr_contactrelationship.indskr_relationshipsourcetype_Formatted"] == selectedSourceTypeFilterValue;
        } else {
          return false;
        }
      });
    }

    slectedFilterValue.forEach(el =>{
      if(el !== 'all'){
        if(el === 'contact'){
          if (this.from === "AccountPageComponent") {
            treeData.children = treeData.children.concat(this.formatAffiliationDataFromAccountRelationship([], [], affiliationData, []))
          } else {
            treeData.children = treeData.children.concat(this.formatAffiliationDataFromContactRelationship(relatedToData, relatedFromData, []));
          }
        }
          else if(el === 'account'){
          //treeData.children = treeData.children.concat(this.formatAffiliationDataFromContactRelationship([], [], this.contactAccountAffiliation));
          if (this.from === "AccountPageComponent") {
            treeData.children = treeData.children.concat(this.formatAffiliationDataFromAccountRelationship(relatedToData, relatedFromData, [], []))
          } else {
            treeData.children = treeData.children.concat(this.formatAffiliationDataFromContactRelationship([], [], affiliationData));
          }
        } else if(el === 'brand'){
          if (this.from === "AccountPageComponent") {
            treeData.children = treeData.children.concat(this.formatAffiliationDataFromAccountRelationship([], [], [], brandData));
          } else {
            treeData.children = treeData.children.concat(this.formatAffiliationDataFromContactRelationship([], [], brandData));
          }
        }
      } else {
        if (this.from === "AccountPageComponent") {
          treeData.children = this.formatAffiliationDataFromAccountRelationship(relatedToData, relatedFromData, affiliationData, brandData)
        } else {
          treeData.children = this.formatAffiliationDataFromContactRelationship(relatedToData, relatedFromData, affiliationData);
        }
      }
    })
  }

  onFilterControlClick(id: string) {
    if (id === 'affilitionType-sort') {
      this.popover
        .create({ component: MultiSelectPopover, componentProps: { root: this.filterAffiliationData }, event: event })
        .then((data) => {
          data.present();
        })
    }
  }

  filterAccountAffiliationOnclick(relatedDataFrom, relatedDataTo, accountData, brandData) {
    let data: AffilitionData[] = [];
    this.filterAffiliationData[0].selectedValues.forEach(filter => {
      switch (filter) {
        case 'account':
          data.push(...this.formatAffiliationDataFromAccountRelationship(relatedDataTo, relatedDataFrom, [], []));
          break;
        case 'contact':
          data.push(...this.formatAffiliationDataFromAccountRelationship([], [], accountData, []));
          break;
        case 'brand':
          data.push(...this.formatAffiliationDataFromAccountRelationship([], [], [], brandData));
          break;
        default:
          data = this.formatAffiliationDataFromAccountRelationship(relatedDataTo, relatedDataFrom, accountData, brandData);
      }
    });
    return data;
  }

  filterContactAffiliationOnclick(relatedDataFrom, relatedDataTo, contactData) {
    let data: AffilitionData[] = [];
    this.filterAffiliationData[0].selectedValues.forEach(filter => {
      switch (filter) {
        case 'contact':
          data.push(...this.formatAffiliationDataFromContactRelationship(relatedDataTo, relatedDataFrom, []));
          break;
        case 'account':
          data.push(...this.formatAffiliationDataFromContactRelationship([], [], contactData));
          break;
        case 'brand':
          data.push(...this.formatAffiliationDataFromContactRelationship([], [], []));
          break;
        default:
          data = this.formatAffiliationDataFromContactRelationship(relatedDataTo, relatedDataFrom, contactData);
      }
    });
    return data;
  }
}

class AffilitionData {
  constructor(
    public entity_id: string,
    public type: string,
    public name: string,
    public value: number,
    public fill: string,
    public stroke: string,
    public affiliationRole: string,
    public affiliationSourceType: string,
    public affiliationType: string,
    public relationship: string,
    public icon: string,
    public Children?: Array<AffilitionData>
  ) {
  }
}
